import { React, useState, Fragment, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import TopActions from '../actions/TopActions';
import Toast from '../actions/Toasts';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useParams,
} from 'react-router-dom';
import apiService from '../../services/apiServices';
import fiscalValidationSchema from '../../services/fiscalValidationSchema';
import InputController from '../../controllers/InputController';
import SelectController from '../../controllers/SelectController';
import { yupResolver } from '@hookform/resolvers/yup';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import globals from '../../services/globals';

const EditFiscalPolitic = () => {
    const logedInUser = globals().getLogedInUser()
    const status = { added: 1, deleted: -1, changed: 2, unchanged: 0 };
    const alert = { open: false, message: '', variant: '' };
    const [toast, setToast] = useState(alert);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const obj = { id: 0, From: 0.0, To: 0.0, Tax: 0, editMode: false, no: 1, status: 0 }
    const [salaries, setSalaries] = useState([obj]);
    const {
        register,
        handleSubmit,
        control,
        setValue,
        watch,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(fiscalValidationSchema),
    });
    const brutoNeto = [{ id: 0, name: "" }, { id: 1, name: "Bruto" }, { id: 2, name: "Neto" }]
    const { id } = useParams();

    const getItem = () => {
        apiService().query('getFiscal', 'id=' + id)
            .then(response => {
                if (response.success) {
                    let item = response.data[0];
                    const fields = Object.keys(response.data[0]);
                    fields.map((field) => {
                        if (field !== 'Type') {
                            if (field === 'From' || field === 'To') setValue(field, formatDate(response.data[0][field]))
                            else setValue(field, response.data[0][field])
                        }
                        else {
                            setValue(
                                'Type', brutoNeto.find(function (e) {
                                    return e.id === response.data[0].Type;
                                })
                            );
                        }

                    });
                    getItemDetails(item.Id)
                }
            })
    }

    const getItemDetails = (id) => {
        apiService().query('getFiscalpoliticsDetails', `FiscalPoliticsId=${id}`)
            .then(response => {
                console.log(response)
                if (response.success) {
                    setSalaries(reOrderItems(setEditModeFalse(response.data)))
                    setValues(reOrderItems(setEditModeFalse(response.data)))
                }
            })
    }

    const setValues = (items) => {
        items.forEach(item => {
            const fields = Object.keys(item);
            fields.map(field => {
                setValue(field + "_"+item.no, item[field])
            });
        })
    }

    const reOrderItems = (items) => {
        let count = 1;
        items.forEach(i => {
            if (i.status !== -1) {
                i.no = count;
                count++
            }
            else {
                i.no = 0;
            }
        });

        return items;
    }

    const setEditModeFalse = (items) => {
        return items.map(obj => ({ ...obj, editMode: false }))
    }

    const onRowClick = (no) => {
        let rowItem = [...salaries]
        rowItem.forEach(i => i.editMode = false);
        rowItem[no - 1].editMode = !rowItem[no - 1].editMode;
        setSalaries(rowItem);
    }

    const addRow = () => {
        let newItem = obj
        newItem.no = Math.max(...salaries.map(o => o.no), 0) + 1
        const newState = [...salaries, newItem];
        setSalaries(countItems(newState))
    }

    const deleteRow = (rowId) => {
        let arrayCopy = [...salaries]
        let item = arrayCopy.find(i => i.no === rowId);
        item.status = -1; //status.deleted;
        setSalaries(countItems(arrayCopy))
    }

    const countItems = (arr) => {
        let count = 1;
        arr.forEach(i => { i.no = count; count++ });
        return arr;
    }

    const onValueChange = (no) => {
        let newArr = [...salaries];
        newArr[no - 1]['status'] = status.changed;
        newArr[no - 1]['From'] = parseFloat(watch('From_' + no))
        newArr[no - 1]['To'] = parseFloat(watch('To_' + no))
        newArr[no - 1]['Tax'] = watch('Tax_' + no)
        setSalaries(newArr);
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const formatDate = (date) => {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }

    const saveSalaries = () => {
        let objs = [], items = reOrderItems([...salaries]), objE = {};

        items?.forEach(item => {
            //item.fiscalPoliticsId = id;
            //item.CreatedBy = logedInUser.data.username
            if (item.id === 0) {
                objE = {};
                objE.id = 0;
                objE.entity = item;
                objE.status = status.added;
                objE.type = "fiscalPoliticsDetails";

                if (item.WorkerId !== 0 && item.no !== 0 && item.status !== -1) {
                    objs.push(objE);
                }
            }
            else {
                objE = {};
                objE.entity = item;
                objE.status = item.status ? item.status : status.unchanged;
                objE.type = "fiscalPoliticsDetails";
                if (objE.status !== status.unchanged) {
                    objs.push(objE)
                }
            }
        });

        console.log(objs)

        if (objs.length > 0) {
            apiService().saveChanges(objs)
                .then((response) => {
                    if (response.success) {
                        setToast({
                            open: true,
                            message: 'U ruajten me sukses!',
                            variant: 'success',
                        });
                        setSalaries(setEditModeFalse(salaries))
                        if (!id) {
                            window.location.href = '#/fiscal/editfiscal/' + id
                        }
                    }
                    else {
                        setToast({
                            open: true,
                            message: 'Ka ndodhur nje gabim!',
                            variant: 'error',
                        });
                    }
                })
        }
        else {
            if (id) {
                setToast({
                    open: true,
                    message: 'Nuk ka ndryshime!',
                    variant: 'info',
                });
            }
            else {
                setToast({
                    open: true,
                    message: 'U ruajten me sukses!',
                    variant: 'success',
                });
            }

        }
    }

    const onSubmit = (data) => {
        data.Type = data.Type.id;
        apiService().put('fiscalPolitics', data)
            .then((response) => {
                if (response.success) {
                    saveSalaries()
                    setToast({
                        open: true,
                        message: 'U ruajten me sukses!',
                        variant: 'success',
                    });
                } else {
                    setToast({
                        open: true,
                        message: 'Ka ndodhur nje gabim!',
                        variant: 'error',
                    });
                }
            });
    };

    const sortBy = (items, property) => {
        return items?.sort((p1, p2) => (parseInt(p1[property]) > parseInt(p2[property])) ? 1 : (parseInt(p1[property]) < parseInt(p2[property])) ? -1 : 0)
    }

    useEffect(() => {
        getItem()
        console.log(formatDate())
    }, [])


    return (
        <div>
            <Fragment>
                <Toast {...toast} />
                <TopActions
                    addNew={() => addRow()}
                    save={handleSubmit(onSubmit)}
                />

                <Card>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>
                            Të dhënat
                        </Typography>
                        <form>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={3} lg={3}>
                                    <InputController
                                        placeholder="Prej"
                                        error={errors.From}
                                        control={control}
                                        register={{ ...register('From') }}
                                        name="From"
                                        type="date"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} lg={3}>
                                    <InputController
                                        placeholder="Deri"
                                        error={errors.To}
                                        control={control}
                                        register={{ ...register('To') }}
                                        name="To"
                                        type="date"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} lg={3}>
                                    <SelectController
                                        placeholder="Tipi"
                                        error={errors.Type}
                                        control={control}
                                        options={brutoNeto}
                                        name="Type"
                                        register={{ ...register('Type') }}
                                    />
                                </Grid>
                                {/* <Grid item xs={12} sm={3} lg={3}>
                                    <InputController
                                        placeholder="Përqindja"
                                        error={errors.Percentage}
                                        control={control}
                                        symbol="%"
                                        register={{ ...register('Percentage') }}
                                    />
                                </Grid> */}

                            </Grid>
                        </form>
                    </CardContent>
                </Card>
                <Card style={{ marginTop: '16px' }}>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>
                            Lista e punetoreve
                        </Typography>

                        <TableContainer component={Paper}>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Nr</TableCell>
                                        <TableCell>Prej</TableCell>
                                        <TableCell>Deri</TableCell>
                                        <TableCell>Tatimi</TableCell>
                                        <TableCell>Add/Remove</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {sortBy(salaries, 'Tax')?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)?.map((w, index) => (w.status !== -1 &&
                                        <TableRow key={w.Id + index}>

                                            <TableCell>{index + 1}</TableCell>

                                            {
                                                w.editMode ?
                                                    <TableCell>
                                                        <InputController onFieldChange={() => onValueChange(w.no)} error={errors['From_' + w.no]} control={control} symbol="€" register={{ ...register('From_' + w.no) }} value={watch('From_' + w.no)} />
                                                    </TableCell>
                                                    :
                                                    <TableCell onClick={function () { onRowClick(w.no) }}>
                                                        {new Intl.NumberFormat('en-GB', {
                                                            style: 'currency',
                                                            currency: 'EUR',
                                                        }).format(w.From)}
                                                    </TableCell>
                                            }
                                            {
                                                w.editMode ?
                                                    <TableCell><InputController onFieldChange={() => onValueChange(w.no)} error={errors['To_' + w.no]} control={control} symbol="€" register={{ ...register('To_' + w.no) }} /></TableCell>
                                                    :
                                                    <TableCell onClick={function () { onRowClick(w.no) }}>
                                                        {new Intl.NumberFormat('en-GB', {
                                                            style: 'currency',
                                                            currency: 'EUR',
                                                        }).format(w.To)}
                                                    </TableCell>
                                            }
                                            {
                                                w.editMode ?
                                                    <TableCell><InputController onFieldChange={() => onValueChange(w.no)} error={errors['Tax_' + w.no]} control={control} symbol="%" register={{ ...register('Tax_' + w.no) }} /></TableCell>
                                                    :
                                                    <TableCell onClick={function () { onRowClick(w.no) }}>
                                                        <p>{watch('Tax_' + w.no)} %</p>
                                                    </TableCell>
                                            }
                                            <TableCell>
                                                <ButtonGroup size="small">
                                                    <Button onClick={() => deleteRow(w.no)}>
                                                        <DeleteIcon />
                                                    </Button>
                                                    {salaries.length === index + 1 &&
                                                        <Button onClick={() => addRow()}>
                                                            <AddIcon />
                                                        </Button>
                                                    }
                                                </ButtonGroup>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {/* </>} */}
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 100]}
                            component="div"
                            count={salaries.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </CardContent>
                </Card>
            </Fragment>
        </div>
    )
}

export default EditFiscalPolitic